import React from "react";
import ButtonThree from "../button/ButtonThree";
import "./AnouncementModal.css";

interface AnouncementModalProps {
  open: boolean;
  announcement: {
    title: string;
    theme: string;
    scripture: string;
    desc: string;
    venue: string;
    address: string;
    venueNote?: string;
    date: string;
    time: string;
    hotels: Array<{
      name: string;
      address: string;
      reservations?: string;
      frontDesk?: string;
      call?: string;
    }>;
    image: string;
    registerUrl?: string;
  } | null;
  onClose: () => void;
}

const AnouncementModal: React.FC<AnouncementModalProps> = ({
  open,
  announcement,
  onClose,
}) => {
  if (!open || !announcement) return null;

  return (
    <div className="anouncement-modal-overlay" onClick={onClose}>
      <div className="anouncement-modal" onClick={(e) => e.stopPropagation()}>
        {/* Close X Button */}
        <button
          className="anouncement-modal-close"
          onClick={onClose}
          aria-label="Close"
        >
          &times;
        </button>
        <img
          src={announcement.image}
          alt={announcement.title}
          className="anouncement-modal-img"
        />
        <div className="anouncement-modal-header">
          <strong>{announcement.title}</strong>
        </div>
        <div className="anouncement-modal-content">
          <div className="anouncement-modal-section">
            <span className="anouncement-modal-label">Theme:</span>{" "}
            <strong>{announcement.theme}</strong>
          </div>
          <div className="anouncement-modal-section">
            <span className="anouncement-modal-label">
              Scripture Reference:
            </span>{" "}
            <strong>{announcement.scripture}</strong>
          </div>
          <div className="anouncement-modal-desc">{announcement.desc}</div>
          <div className="anouncement-modal-section">
            <span className="anouncement-modal-label">Venue:</span>
            <div>
              {announcement.venue}
              <br />
              {announcement.address}
              <br />
              {announcement.venueNote && (
                <>
                  {announcement.venueNote}
                  <br />
                </>
              )}
            </div>
          </div>
          <div className="anouncement-modal-section">
            <span className="anouncement-modal-label">Dates:</span>{" "}
            <strong>{announcement.date}</strong>
          </div>
          <div className="anouncement-modal-section">
            <span className="anouncement-modal-label">Time:</span>{" "}
            <strong>{announcement.time}</strong>
          </div>
          <div className="anouncement-modal-section">
            <span className="anouncement-modal-label">
              Hotel Accommodation Nearby
            </span>
            <div className="anouncement-modal-hotels">
              {announcement.hotels.map((hotel, idx) => (
                <div key={idx}>
                  <strong>{hotel.name}</strong>
                  <br />
                  {hotel.address}
                  <br />
                  {hotel.reservations && (
                    <>
                      Reservations: {hotel.reservations}
                      <br />
                    </>
                  )}
                  {hotel.frontDesk && (
                    <>
                      Front Desk: {hotel.frontDesk}
                      <br />
                    </>
                  )}
                  {hotel.call && (
                    <>
                      Call: {hotel.call}
                      <br />
                    </>
                  )}
                </div>
              ))}
            </div>
            <div className="anouncement-modal-desc">
              Whether you’re traveling from within the U.S. or internationally,
              these hotels provide excellent access to the conference venue.
            </div>
          </div>
          <div className="anouncement-modal-desc">
            Don’t miss this prophetic gathering of freedom and restoration. Your
            life, family, and destiny will never be the same again.
          </div>
          <div className="anouncement-modal-register">
            <span role="img" aria-label="point right"></span>{" "}
            <ButtonThree
              text="Register Now"
              onClick={() =>
                window.open(
                  announcement.registerUrl ||
                    "https://chantalekabeministries.com/?nucleuslauncher=openflow&nlflow=4bebbdfc02e9dcba45be",
                  "_blank"
                )
              }
              width="60%"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default AnouncementModal;
